import {customAxios} from "../customAxios";
import {useState} from "react";

export function useEnableImportVehicle() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    async function execute(importId: number, vehicleId: number) {
        try {
            setLoading(true);
            setError(undefined);
            await enableImportVehicle(importId, vehicleId);
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, error, execute
    };
}

export async function enableImportVehicle(importId: number, vehicleId: number): Promise<void> {
    const response = await customAxios.put<void>(`/v1/lease-packages/import/${importId}/vehicle/${vehicleId}`, );
    return response.data;
}

export function useDisableImportVehicle() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    async function execute(importId: number, vehicleId: number) {
        try {
            setLoading(true);
            setError(undefined);
            await disableImportVehicle(importId, vehicleId);
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, error, execute
    };
}

export async function disableImportVehicle(importId: number, vehicleId: number): Promise<void> {
    const response = await customAxios.delete<void>(`/v1/lease-packages/import/${importId}/vehicle/${vehicleId}`, );
    return response.data;
}

